import {
  FormField,
  FormSection,
  FormStep,
} from "@/components/FormEngine/types";

export const getAllFieldsFromSection = (section: FormSection): FormField[] => {
  const collected: FormField[] = [];
  for (const subSection of section.subSections.values()) {
    for (const row of subSection.rows) {
      collected.push(...row.fields);
    }
  }

  return collected;
};

export const getAllFieldsFromStep = (step: FormStep): FormField[] => {
  const collected: FormField[] = [];
  for (const section of step.sections.values()) {
    collected.push(...getAllFieldsFromSection(section));
  }

  return collected;
};
